import { View, tokens } from '@sapphire-react/core';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  disabled?: boolean;
  addBottomMargin?: boolean;
  border?: string;
  display?: string;
  borderRadius?: number | string;
  paddingX?: number | string;
  paddingTop?: number | string;
  paddingBottom?: number | string;
};

export function ResultWhiteBox({
  children,
  disabled,
  addBottomMargin,
  border,
  display = 'flex',
  borderRadius = 4,
  paddingX = 16,
  paddingTop = 24,
  paddingBottom = 24,
}: Props) {
  return (
    <View
      aria-disabled={disabled}
      display={display}
      flexDirection={'column'}
      alignItems={'center'}
      borderRadius={borderRadius}
      paddingLeft={paddingX}
      paddingRight={paddingX}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      marginBottom={addBottomMargin ? tokens.size.spacingLg : 0}
      backgroundColor={tokens.color.backgroundSurface.value}
      border={border ?? `1px solid ${tokens.color.borderSecondary.value}`}
      UNSAFE_style={{ opacity: disabled ? 0.4 : 1 }}
    >
      {children}
    </View>
  );
}
